/* eslint-disable */

import { fetchUsers } from 'common/src/api/users';
import { fetchTasks as apiFetchTasks } from 'common/src/api/tasks';
import { User, Tasks, Asker, Tasker } from 'common/src/utils/types';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { fetchTaskersWithPagination } from 'common/src/api/taskers';
import { fetchAllAsker } from 'common/src/api/askers';

interface GeneralStoreState {
  users: User[];
  setUsers: (users: User[]) => void;
  fetchUsers: () => Promise<void>;
  tasks: Tasks[];
  totalPages: number;
  setTasks: (tasks: Tasks[]) => void;
  fetchTasks: (
    page?: number,
    limit?: number,
    sortOrder?: 'asc' | 'desc',
  ) => Promise<void>;
  currentPage: number;
  setCurrentPage: (page: number) => void;
  askers: Asker[];
  fetchAskers: () => Promise<void>;
  taskers: Tasker[];
  setTaskers: (taskers: Tasker[]) => void;
  total: number;
  setTotal: (total: number) => void;
  fetchTaskers: (page: number, pageSize: number) => Promise<void>;
}

const useGeneralStore = create<GeneralStoreState>()(
  persist(
    (set) => ({
      users: [],
      setUsers: (users: User[]) => set({ users }),
      fetchUsers: async () => {
        const users = await fetchUsers();
        set({ users });
      },
      tasks: [],
      totalPages: 1,
      setTasks: (tasks) => set({ tasks }),
      fetchTasks: async (
        page?: number,
        limit?: number,
        sortOrder: 'asc' | 'desc' = 'asc',
      ) => {
        try {
          const { data, totalPages } = await apiFetchTasks(
            page,
            limit,
            sortOrder,
          );
          set({ tasks: data, totalPages });
        } catch (error) {
          console.error('Error fetching tasks:', error);
        }
      },
      currentPage: 1,
      setCurrentPage: (page: number) => set({ currentPage: page }),
      askers: [],
      fetchAskers: async () => {
        try {
          const { data, error } = await fetchAllAsker()
          if (error) throw error;
          set({ askers: data || [] });
        } catch (error) {
          console.error('Error fetching askers:', error);
        }
      },
      taskers: [],
      setTaskers: (taskers) => set({ taskers }),
      total: 0,
      setTotal: (total) => set({ total }),
      fetchTaskers: async (page: number, pageSize: number) => {
        try {
          const { taskers: fetchedTaskers, total } = await fetchTaskersWithPagination(page, pageSize);
          set({ taskers: fetchedTaskers, total });
        } catch (error) {
          console.error('Error fetching taskers:', error);
        }
      },
    }),
    {
      name: 'generalStore',
    },
  ),
);

export default useGeneralStore;
